export default "__VITE_ASSET__CtwnRAdv__"